import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchProprietaire = () => async (dispatch) => {
  try {
    const response = await instance.get("prorietaires");
    console.log("REPONSEPROPRIETAIRE", response);
    dispatch(fetchProprietaireFulfilled(response?.data.data));
  } catch (error) {
    console.log();
  }
};
// export const removeFlagCommandes = (payload) => async (dispatch) => {
//   try {
//     const response = await instance.post("/updateFlagCommande/" + payload);
//     console.log("REPONSEBIENS", response);
//     if (response.status === true) {
//       dispatch(removeItem());
//     }
//   } catch (error) {
//     console.log();
//   }
// };
export const proprietaireReducer = createSlice({
  name: "Proprietaire",
  initialState: { Proprietaire: [],totalProprietaire:null },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.commande_length - 1;
      return { ...state, commande_length: nouveau_length };
    },
    fetchProprietaireFulfilled: (state, action) => {
      return {...state,Proprietaire:action.payload,totalProprietaire:action.payload.length}
    },
  },
});

export const { handleTotalNew, fetchProprietaireFulfilled, removeItem } =
  proprietaireReducer.actions;
export default proprietaireReducer.reducer;
